import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

const PlanoDropDownMenu = ({
  menuOptions,
  handleChange,
  value,
  setValue,
  disabled = false,
  children,
}) => {
  return (
    <FormControl
      fullWidth
      disabled={disabled}
      variant="filled"
      sx={{
        marginTop: "1rem",
        borderRadius: "20px",
      }}
      size="small"
    >
      <InputLabel
        sx={{
          color: "black",
          display: "flex",
        }}
        id={children}
      >
        {children}
      </InputLabel>
      <Select
        value={value}
        label={value}
        onChange={handleChange}
        sx={{
          borderRadius: "8px",
          backgroundColor: "#f3f7f9",
        }}
      >
        {menuOptions ? (
          menuOptions.map((elem, index) => (
            <MenuItem value={elem} key={index}>
              {elem}
            </MenuItem>
          ))
        ) : (
          <>
            <MenuItem>Twenty</MenuItem>
            <MenuItem>Thirty</MenuItem>
          </>
        )}
      </Select>
    </FormControl>
  );
};

export default PlanoDropDownMenu;
